import { render, staticRenderFns } from "./BusChangeGradesSetupDialog.vue?vue&type=template&id=4296d122&scoped=true&"
import script from "./BusChangeGradesSetupDialog.vue?vue&type=script&lang=js&"
export * from "./BusChangeGradesSetupDialog.vue?vue&type=script&lang=js&"
import style0 from "./BusChangeGradesSetupDialog.vue?vue&type=style&index=0&id=4296d122&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4296d122",
  null
  
)

export default component.exports